// Initial State
const initialState = {
  globalCommissionRates: null,
};

// Action constants
const GET_GLOBAL_COMMISSION_RATES = 'GET_GLOBAL_COMMISSION_RATES';
const GET_GLOBAL_COMMISSION_RATES_SUCCESS = 'GET_GLOBAL_COMMISSION_RATES_SUCCESS';
const GET_GLOBAL_COMMISSION_RATES_FAILURE = 'GET_GLOBAL_COMMISSION_RATES_FAILURE';

// Action creators
export const getGlobalCommissionRates = () => {
  return {
    types: [GET_GLOBAL_COMMISSION_RATES, GET_GLOBAL_COMMISSION_RATES_SUCCESS, GET_GLOBAL_COMMISSION_RATES_FAILURE],
    payload: {
      request: {
        url: `/configurations?key=global_commission_rates`,
        method: 'GET',
      }
    }
  };
};

const configurationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GLOBAL_COMMISSION_RATES:
      return {
        ...state,
        error: null,
        isLoading: true
      };

    case GET_GLOBAL_COMMISSION_RATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload?.data?.error
      };

    case GET_GLOBAL_COMMISSION_RATES_SUCCESS:
      return {
        ...state,
        globalCommissionRates: action.payload.data.data && action.payload.data.data[0],
        isLoading: false
      };

    default:
      return state;
  }
};

export default configurationsReducer;
